import React from 'react';
import classNames from 'classnames';
import './CountWithTitle.pcss';
import { Heading } from '../Heading/Heading';
import { HelpText } from '../HelpText/HelpText';

type Props = {
  className?: string;
  isActive?: boolean;
  count?: number | string | null;
  text?: string;
};

export const CountWithTitle = ({ className, count, isActive, text }: Props) => {
  return (
    <div
      className={classNames(className, 'c-count-title', {
        'c-count-title--active': isActive,
      })}
    >
      <Heading
        size={5}
        text={count === undefined || count === null ? '?' : String(count)}
      />
      <HelpText text={text || ''} />
    </div>
  );
};
